import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "../../../redux/store";
import { getNotesToTimecardRecord } from "../../../redux/features/EmployeeTimeCard";
import { useParams } from "react-router";
import {
  formatTimeCardDate,
  formatTimeCardTime,
} from "../../../utils/employeeTimeCardhelper";
import { setTopNavNameTitle } from "../../../redux/features/mobileLayout";
import { Loader } from "lucide-react";
import AddNoteTimecard from "./AddNoteTimecard";
import PullToRefresh from "pulltorefreshjs";
import { setShowTopNav } from "../../../redux/features/mobileLayout";

const TimecardRecordNotesListData: React.FC = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const { timecardNotesData } = useSelector(
    (state: RootState) => state.employeeTimeCardData
  );
  const [loading, setLoading] = useState<boolean>(false);
  const user = useSelector((state: any) => state?.user?.user);
  useEffect(() => {
    if (user?.id) {
      const payload = { id: Number(params?.id), employee_id: user?.id }; // Example payload, adjust as needed
      setLoading(true);
      dispatch(getNotesToTimecardRecord(payload)).finally(() =>
        setLoading(false)
      );
    }
  }, [dispatch, user?.id, params?.id]);

  useEffect(() => {
    dispatch(setTopNavNameTitle("Timecard Notes"));
  }, []);
   const fetchInitialDashboardData = async () => {
      if (!user?.id) return;
      if (user?.id) {
        setLoading(true);
        try {
          const payload = { id: Number(params?.id), employee_id: user?.id };
          await  dispatch(getNotesToTimecardRecord(payload))
        } catch (error) {
          console.error("Error fetching audit logs:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    const refreshData = useCallback(async () => {
      fetchInitialDashboardData();
    }, [dispatch, user?.id]);
  useEffect(() => {
    // refreshData();

    PullToRefresh.init({
      mainElement: "#refresh-container",
      onRefresh: () => refreshData(),
      instructionsPullToRefresh: "Pull to refresh",
      instructionsReleaseToRefresh: "Release to refresh",
      getMarkup: () => `
                    <div class="w-full h-16 flex items-center justify-center bg-white shadow-sm">
                        <div class="w-full flex items-center justify-center">
                        <div class="flex items-center justify-center gap-2 text-sm text-gray-600">
                            <div class="h-4 w-4 border-2 border-t-transparent border-gray-500 rounded-full animate-spin"></div>
                            <span>Refreshing...</span>
                        </div>
                        </div>
                    </div>
                    `,
      distThreshold: 40,
      distMax: 60,
      distReload: 50,
      shouldPullToRefresh() {
        const container = document.getElementById("refresh-container");
        return container?.scrollTop === 0;
      },
    });
    return () => {
      PullToRefresh.destroyAll();
      dispatch(setShowTopNav(true));
    };
  }, [refreshData]);

  return (
    <div id="refresh-container" className="h-full overflow-y-auto bg-white">
      <div className="container mx-auto p-6 bg-white rounded-lg shadow-lg">
        {loading ? (
          <div className="flex justify-center items-center py-4">
            <Loader
              size={32}
              color="#2664eb"
              strokeWidth={2.5}
              absoluteStrokeWidth
              className="animate-spin"
            />
          </div>
        ) : Array.isArray(timecardNotesData?.data) ? (
          <ul className="space-y-4">
            {timecardNotesData?.data?.map((note) => (
              <li
                key={note.notes_id}
                className="flex flex-col bg-gray-50 px-4 py-4 rounded-lg border-solid border border-gray-400 transition-shadow"
              >
                <div className=" items-center mb-2">
                  <div className="text-md font-semibold ">
                    {note.notes_json ? (
                      <span className="">
                        {JSON.parse(note.notes_json).notes}
                      </span>
                    ) : (
                      <span className="text-gray-500">No notes available</span>
                    )}
                  </div>
                  <div className="text-sm text-black-500">
                    {formatTimeCardTime(note.created)},
                    {formatTimeCardDate(note.created)}
                  </div>
                </div>
                <div className="text-sm text-black-500">
                  Created by:{" "}
                  <span className="text-blue-600 font-bold">
                    {" "}
                    {note.first_name} {note.last_name}
                  </span>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <div className="text-center text-gray-500 text-xl">
            No notes available
          </div>
        )}
        <div className=" mt-4">
          <AddNoteTimecard loading={loading} setLoading={setLoading} />
        </div>
      </div>
    </div>
  );
};

export default TimecardRecordNotesListData;
